export const getSchemaLink = (schemaIdentity) => {
    return '/Schema/' + schemaIdentity;
};
